import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function employees(state = initialState.employees, action) {
    switch (action.type) {
        case types.LOAD_EMPLOYEES_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
            })
        case types.LOAD_EMPLOYEES_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: '',
                data: action.payload
            })
        case types.LOAD_EMPLOYEES_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                errorMessage: {
                    ...action.payload
                }
            })

        case types.LOAD_COMPANY_ADMINS_REQUEST:
            return Object.assign({}, state, {
                ...state,
                admins: {
                    ...state.admins,
                    isFetching: true,
                }
            })
        case types.LOAD_COMPANY_ADMINS_SUCCESS:
            return Object.assign({}, state, {
                ...state,
                admins: {
                    ...state.admins,
                    isFetching: false,
                    errorMessage: '',
                    results: action.payload
                }
            })
        case types.LOAD_COMPANY_ADMINS_FAILURE:
            return Object.assign({}, state, {
                ...state,
                admins: {
                    ...state.admins,
                    isFetching: false,
                    errorMessage: {
                        ...action.payload
                    }
                }
            })

        case types.UPDATE_EMPLOYEE_SUCCESS:
            let isAdmin = action.payload.is_admin;
            let updateData = Object.assign({}, state);

            let updateIndex = state.data.results.findIndex(item => item.user.id === action.user_id);
            let updateAdmin = state.admins.results.findIndex(item => item.user.id === action.user_id);

            if(isAdmin && updateAdmin < 0){
                updateData.admins.results = [
                    ...updateData.admins.results,
                    action.payload
                ]
            }

            if(!isAdmin && updateAdmin >= 0){
                updateData.admins.results.splice(updateAdmin, 1);
            }

            updateData.data.results.splice(updateIndex, 1, action.payload);

            return updateData;

        case types.DELETE_EMPLOYEE_SUCCESS:
            let deleteData = Object.assign({}, state);

            let deleteIndex = state.data.results.findIndex(item => item.user.id === action.payload.user_id);

            deleteData.data.results.splice(deleteIndex, 1);

            return deleteData;

        case types.RESET_ALL_INFO:
            return initialState.employees

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/employeesReducer.js